import * as React from "react"
import { Progress } from "@/components/ui/progress"
import { cn } from "@/lib/utils"

interface ProfileStrengthBadgeProps {
  strength: number
  className?: string
  showPercentage?: boolean
}

export function ProfileStrengthBadge({ 
  strength, 
  className,
  showPercentage = true 
}: ProfileStrengthBadgeProps) {
  // Color coding based on completion percentage
  const getStrengthColorClass = (strength: number) => {
    if (strength < 30) return "bg-destructive"
    if (strength < 70) return "bg-orange-500"
    return "bg-green-500"
  }

  // Text color for percentage display
  const getTextColor = (strength: number) => {
    if (strength < 30) return "text-destructive"
    if (strength < 70) return "text-orange-600 dark:text-orange-400"
    return "text-green-600 dark:text-green-400"
  }

  return (
    <div className={cn("flex items-center gap-2 min-w-0", className)}>
      <div className="flex-1 min-w-0">
        <Progress 
          value={strength} 
          className="h-2 w-full bg-muted/50"
          indicatorClassName={getStrengthColorClass(strength)}
        />
      </div>
      {showPercentage && (
        <span className={cn(
          "text-xs font-medium tabular-nums shrink-0",
          getTextColor(strength)
        )}>
          {Math.floor(strength)}%
        </span>
      )}
    </div>
  )
}
